/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Trigger type of an avalanche
 * @export
 * @enum {string}
 */

export const TriggerType = {
    Natural: 'NATURAL',
    Person: 'PERSON',
    Explosive: 'EXPLOSIVE',
    SnowGroomer: 'SNOW_GROOMER',
    Other: 'OTHER',
    Unknown: 'UNKNOWN'
} as const;

export type TriggerType = typeof TriggerType[keyof typeof TriggerType];



